import { render } from "./LogoutComponent.vue?vue&type=template&id=c82eff20&ts=true"
import script from "./LogoutComponent.vue?vue&type=script&lang=ts"
export * from "./LogoutComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__